module.exports = __webpack_public_path__ + "components/flag/static/square/eg-9c6a7b32afddbff87b8bada76fdb43fd.svg";